export interface Holdings {
  security: {
    code: string
    exchangeCode: string
    tickerSymbol: string
  }
  quantity: number
  state?: "VALID" | "INVALID"
}

export interface CombinedHoldingData {
  security: string
  quantity: number
}

export interface Security {
  code: string
  company_code: string
  exchange: string
  symbol: string
  type: string
  created_at: string
  updated_at: string
  status: string
}

export enum BROKER_CONNECTION_STATE {
  AUTHORIZED = "AUTHORIZED",
  IN_PROGRESS = "IN_PROGRESS",
}

export enum PORTFOLIO_TYPE {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
}

enum PORTFOLIO_STATUS {
  VALID = "VALID",
  INVALID = "INVALID",
  EXPIRED = "EXPIRED",
}

export type Broker = {
  broker?: string | null
  id: string
  name: string
  logo: string | null
  active?: boolean | null
  connectionId?: string | null
  state?: BROKER_CONNECTION_STATE | null
  attachParameters?: {
    login: Object
    password: Object
    option?: Object
  }
}

export type PortfolioResponse = {
  broker: string
  createdBy: string
  creationType: PORTFOLIO_TYPE
  date: string
  holdings: Holdings
  state: PORTFOLIO_STATUS
  userId: string
  hasProofOfOwnership: boolean
}

export type PortfolioPayload = {
  userId: string
  broker: string
  holdings: Holdings[]
  poo?: {
    id: string
    date: string
  }
}
